import { Response } from "../../../../types/Response.interface";
import { apiClient } from "../../../../utils/apiClient";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useRouter } from "next/router";
import * as yup from "yup";

export interface Inputs {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  message: string;
  isRealtor: boolean;
}

const schema = yup
  .object({
    firstName: yup.string().required().label("first name"),
    lastName: yup.string().optional().label("last name"),
    phone: yup.string().min(14).max(16).required(),
    email: yup.string().email().required(),
    isRealtor: yup.boolean().optional(),
    message: yup.string().optional(),
  })
  .required();

const usePreLead = (callback?: () => void) => {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isDirty },
  } = useForm<Inputs>({
    resolver: yupResolver(schema),
  });

  const router = useRouter();

  const onSubmit = async (result: Inputs) => {
    const { email, firstName, isRealtor, lastName, message, phone } = result;

    const res: Response = await apiClient.post("/api/v1/track/prelead", {
      name: `${firstName} ${lastName}`,
      email,
      phone,
      isRealtor,
      message,
      from: router.query.slug,
    });

    if (!res.ok) {
      if (res.error === "SERVER") {
        res.message?.map((err) => {
          setError("lastName", {
            message: err,
          });
        });
      }
    } else {
      callback?.();
    }
  };

  return {
    register,
    handleSubmit,
    errors,
    isDirty,
    onSubmit,
  };
};

export default usePreLead;
